//Core
import React, { useState } from "react"
import { Link } from "gatsby"

//Styles
import style from "./style.module.scss"
import Pulse from "react-reveal/Pulse"

const { Container, Wrapper, Image, Text } = style

const PromoItem = ({ title = "Промо ТАСКОМБАНК", link = "/", image = "" }) => {
  const [pulse, setPulse] = useState(false)
  const mouseLeave = () => setPulse(false)
  const mouseEnter = () => setPulse(true)

  return (
    <Pulse when={pulse}>
      <div
        className={Container}
        onMouseEnter={mouseEnter}
        onMouseLeave={mouseLeave}
      >
        <div className={Wrapper}>
          <Link to={link} target="_blank" rel="noopener noreferrer">
            <img
              src={image}
              alt={title}
              draggable="false"
              className={Image}
            ></img>
          </Link>
          <Link to={link} target="_blank" rel="noopener noreferrer">
            <h2 className={Text}>{title}</h2>
          </Link>
        </div>
      </div>
    </Pulse>
  )
}

export default PromoItem
